function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M135,0c-8.291,0-15,6.709-15,15v105H90V15c0-8.291-6.709-15-15-15S60,6.709,60,15v105H30V15c0-8.291-6.709-15-15-15 S0,6.709,0,15c0,66.683,0,83.276,0,150c0,24.814,20.186,46,45,46h60c24.814,0,45-21.186,45-46c0-66.747,0-83.28,0-150 C150,6.709,143.291,0,135,0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M362,316V171.328c0-0.042,0.007-0.082,0.007-0.124C337.248,140.25,298.631,120,256,120c-27.288,0-54.128,8.077-76,22.787 V165c0,30.676-18.56,58.036-45,69.643v81.907C157.286,360.506,203.434,391,256,391c44.998,0,85.659-22.341,110.202-56.285 C363.567,328.999,362,322.696,362,316z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M407,361c-6.969,0-13.491-1.727-19.385-4.567C357.419,395.611,309.174,421,256,421c-47.296,0-90.888-20.114-121-52.103 v78.199C169.757,469.086,211.829,482,256,482c65.288,0,124.898-28.977,166-73.394V361H407z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M256,30c-26.34,0-52.509,4.759-76,13.076v64.916C202.83,96.313,229.349,90,256,90c41.803,0,80.909,15.753,110.016,41.47 c3.891-21.182,10.437-41.64,19.951-60.674C349.43,45.167,304.019,30,256,30z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M504.075,1.772c-4.849-2.607-10.781-2.314-15.396,0.747C420.268,48.127,392,107.075,392,171.328V316 c0,8.291,6.709,15,15,15h45v151c0,16.567,13.431,30,30,30c16.569,0,30-13.433,30-30c0-239.87,0-231.638,0-467 C512,9.463,508.953,4.38,504.075,1.772z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M45,241v241c0,16.567,13.431,30,30,30c16.569,0,30-13.433,30-30V241H45z"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var SvgDinner = function SvgDinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dinner.1262b7aa.svg";
export { ForwardRef as ReactComponent };